import { createSlice, nanoid } from "@reduxjs/toolkit";
const initialState = {
  queue: []
};
const flashSlice = createSlice({
  name: "flash",
  initialState,
  reducers: {
    pushFlash: {
      reducer(state, action) {
        state.queue.push(action.payload);
      },
      prepare(message, severity = "info") {
        return {
          payload: {
            id: nanoid(),
            message,
            severity,
            createdAt: Date.now()
          }
        };
      }
    },
    shiftFlash(state) {
      state.queue.shift();
    },
    clearFlash(state) {
      state.queue = [];
    }
  }
});
export const {
  pushFlash,
  shiftFlash,
  clearFlash
} = flashSlice.actions;
export const selectFlashQueue = state => state.flash.queue;
export default flashSlice.reducer;